import { EditorState, Modifier } from 'draft-js';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import { customHTML2Content } from '../../utils/editor';

import './toolbar-link-button.styles.scss';

export const ToolbarLinkButton = (props) => {
	const { editorState, onChange, className } = props;

	const execute = () => {
    const contentState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      customHTML2Content('<a href="{LINK}">Click here to begin your Online Family History Questionnaire</a>')
    );

    onChange(EditorState.push(editorState, contentState, "insert-fragment"));
	};

	return (
		<span 
      className={cx('rdw-option-wrapper TextEditorToolbarLinkButton', className)} 
      title={I18n.t("Insert hyperlink with {LINK} placeholder")}
      onClick={execute}
    >
      {'{L}'}
    </span>
	);
};